<template>
    <ServiceHeader />
    <ServiceBody />
  
</template>
  
<script>
  import ServiceHeader from '../molecules/ServiceHeader.vue'
  import ServiceBody from '../molecules/ServiceBody.vue'
  
  export default {
    name: 'ServiceView',
    components: {
      ServiceHeader,
      ServiceBody
    }
  }
</script>

<style scoped>

</style>
  